import React, { useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'

import AppContext from '../../../context/appContext'

import {
  ScreenContainer,
  MainHeader,
  MainContentContainer,
  MainSubHeader,
  VerticalDivider,
  MealIngredientName,
  MealIngredientKcalValue,
  MealIngredientWeightValue,
  MealIngredientRow,
  MealsMainHeader,
  BigHeader,
  DietStandardRow,
  MainDietButtonsContainer,
} from '../Shared/SharedStyledComponents'
import { TopColorBar } from '../../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import BackButton from '../../shared/BackButton'
// import NavigationBar from '../../shared/NavigationBar/NavigationBarContainer'

import {
  DaySwitcherButton,
  DaySwitcherDate,
} from '../DietMainScreen/subComponents/DailyBalanceStyles'
import DemoModeAnnouncement from '../../DemoModeAnnouncement/DemoModeAnnouncement.jsx'

import {
  ShoppingListColumn,
  ShippingItem,
  ShippingListName,
  ShippingListColumn,
  ShippingListWeight,
  ShippingListButtonRemove,
  NoElements,
} from './ShoppingListScreenStyles'

import { MealsContainer } from '../style/DietStyle'
import Navigation from '../../Challenges/components/Navigation/Navigation'

import NavigationBar from '../../NavigationBar/NavigationBar'
import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericMobileTopNavigation from '../../../GenericComponents/GenericMobileTopNavigation'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericIcon from '../../../GenericComponents/GenericIcon'

import ProductIcon from '../../../assets/REDESIGN_Assets/Diet/product-icon.svg'
import RemoveIcon from '../../../assets/REDESIGN_Assets/Diet/remove-item-icon.svg'
import { removeMealFromCart } from '../../../Api/dietApi/userInfo'
import ProductDietIcon from '../../../assets/REDESIGN_Assets/Diet/product-diet-icon.svg'

import { DietStandardButton } from '../Shared/SharedStyledComponents'
import TrashIcon from '../../../assets/REDESIGN_Assets/theme/trash-icon.png'
import productIc from '../../../assets/REDESIGN_Assets/theme/product-ic.png'
interface ShoppingListScreenProps {
  dietCart: any
  diet: any
  formattedDate: any
  selectPrevDay: any
  selectNextDay: any
  removeItemFromCart: any
  checkItem: any
  changeDiet: any
  isDemoAccount: boolean
  challengeMode: boolean
}

const ShoppingListScreen: React.FC<ShoppingListScreenProps> = ({
  dietCart,
  diet,
  formattedDate,
  selectPrevDay,
  selectNextDay,
  removeItemFromCart,
  checkItem,
  changeDiet,
  isDemoAccount,
  challengeMode
}) => {
  let history = useHistory()
  const location = useLocation()
  const appContext = useContext(AppContext)
  // const dietType = location.state.dietType
  // const mealName = location.state.chosedMeal

  const goToMainPage = () => {
    history.push({
      pathname: `/dieta`,
    })
  }

  return (
    <GenericBackgroundLayer
      className={`${appContext.appState.theme == 'light' ? 'light' : 'standard'
        }`}
      fDir="column"
      justify="flex-start"
    >
      {challengeMode ? <Navigation /> : <NavigationBar
        isPlayerView={false}
        backButtonAction={() => history.push('/dieta')}
      />}
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          handleClick={() => challengeMode ? history.push({ pathname: '/dieta', state: { challengeMode: true } }) : history.push('/dieta')}
          dietCartClick={null}
        />
      )}

      <GenericMainCard
        flexDir={'column'}
        width={isMobile ? '95%' : '60%'}
        className="standard"
        margin={'3% 0 0 0'}
      >
        <GenericRow
          width={'80%'}
          justify="center"
          margin={'0 0 5% 0'}
          align={'center'}
        >
          <GenericTextSpan fSize={isMobile ? '2rem' : '1.4rem'}>
            Lista zakupów
          </GenericTextSpan>
        </GenericRow>
        <GenericRow margin={'0 0 3% 0'}>
          <DaySwitcherButton prev onClick={selectPrevDay} />
          <DaySwitcherDate> {formattedDate} </DaySwitcherDate>
          <DaySwitcherButton next onClick={selectNextDay} />
        </GenericRow>
        <MealsContainer className="shopping-list">
          {dietCart && dietCart.length ? (
            dietCart.map((item: any) => (
              <GenericRow margin={'2% 0'} wrap={'wrap'}>
                <GenericRow
                  width={'100%'}
                  justify="space-between"
                  padding={'0 3%'}
                >
                  <GenericRow width={'50%'} justify="flex-start">
                    {/* <GenericIcon
                      margin={'0 3% 0 0'}
                      src={productIc}
                      width={isMobile ? '3vw' : '1vw'}
                      height={isMobile ? '3vw' : '1vw'}
                    ></GenericIcon> */}
                    <GenericTextSpan
                      tAlign={'left'}
                      fWeight={'bold'}
                      fSize={isMobile ? '1rem' : '0.8rem'}
                    >
                      {' '}
                      {item.ingredient_detail.ingredient}
                    </GenericTextSpan>
                  </GenericRow>
                  <GenericRow width={'50%'} justify="flex-end">
                    <GenericIcon
                      className={'button-style'}
                      src={TrashIcon}
                      width={isMobile ? '3.5vw' : '1vw'}
                      height={isMobile ? '3.5vw' : '1vw'}
                      onClick={() => removeItemFromCart(item.id)}
                    ></GenericIcon>
                  </GenericRow>
                </GenericRow>
                <GenericRow
                  padding={'0 6%'}
                  margin={'1% 0 0 1%'}
                  width={'100%'}
                  justify="flex-start"
                >
                  <GenericTextSpan fSize={isMobile ? '0.8rem' : '0.8rem'}>
                    {' '}
                    {item.ingredient_detail.amount}{' '}
                    {item.ingredient_detail.unit}
                  </GenericTextSpan>
                </GenericRow>
              </GenericRow>
            ))
          ) : (
            <GenericTextSpan fSize={'1.2rem'} fWeight="bold">
              Brak produktów w koszyku
            </GenericTextSpan>
          )}
        </MealsContainer>
      </GenericMainCard>
    </GenericBackgroundLayer>
  )
}

export default ShoppingListScreen
